/* eslint-disable */
export default {
  _background1: 'background1',
  _background2: 'background2',
  _scoreboard: 'scoreboard',
  _bunny: 'bunny',
  _title: 'title',
  _go_button: 'go_button',
  _egg: 'egg',
  _speaker_on: 'speaker_on',
  _speaker_off: 'speaker_off',
  _background3: 'background3',
  _background4: 'background4',
  _background5: 'background5',
  _background6: 'background6',
  _background7: 'background7',
  _background8: 'background8',
  _background9: 'background9',
  _title_background: 'title_background',
}